import React from 'react';

import StringUtils from 'helpers/stringUtils';

const stringUtils = new StringUtils();

const DriversSchedule = ({ drivers }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-2">
        Driver Schedule
      </h2>

      <div className="w-full flex justify-center">
        <p className="text-sm mb-4 max-w-2xl">
          It is hereby noted and agreed that the vehicle(s) and
          trailer(s) specified in the schedule are only covered while
          being operated by the following person(s):
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold text-center">
              <th className="px-4 py-2">First Name</th>
              <th className="px-4 py-2">Last Name</th>
              <th className="px-4 py-2">DL #</th>
              <th className="px-4 py-2">DL State</th>
              <th className="px-4 py-2">Years Exp.</th>
              <th className="px-4 py-2">DOB</th>
            </tr>
          </thead>
          <tbody>
            {drivers?.map((driver, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? 'bg-white text-sm'
                    : 'bg-gray-50 text-sm'
                }
              >
                <td className="px-4 py-2 font-bold">
                  {driver.firstName}
                </td>
                <td className="px-4 py-2 font-bold">
                  {driver.lastName}
                </td>
                <td className="px-4 py-2">{driver.licenseNumber}</td>
                <td className="px-4 py-2 font-mono text-sm">
                  {stringUtils.getStateByAbbreviation(
                    driver.licenseState
                  )}
                </td>
                <td className="px-4 py-2">
                  {driver.yearsExperience}
                </td>
                <td className="px-4 py-2">{driver.dateOfBirth}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DriversSchedule;
